import { render, staticRenderFns } from "./work_order_tab.vue?vue&type=template&id=6074ce8b"
import script from "./work_order_tab.vue?vue&type=script&lang=js"
export * from "./work_order_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports